import { HttpClient } from '@angular/common/http';
import { LocaleService } from '@app/services/locale/locale.service';
import interpolate from '@app/shared/utils/string/interpolate';
import { AffiliationsService } from '../affiliations/affiliations.service';
import { ConfigService } from '@core/config.service';
import { ExpirableSessionStorageService } from '@app/shared/services/expirable-storage/expirable-session-storage.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../locale/locale.service";
import * as i3 from "../affiliations/affiliations.service";
import * as i4 from "../../core/config.service";
import * as i5 from "../../shared/services/expirable-storage/expirable-session-storage.service";
var ResourceBundleService = /** @class */ (function () {
    function ResourceBundleService(httpClient, localeService, affiliationService, configService, storage) {
        this.httpClient = httpClient;
        this.localeService = localeService;
        this.affiliationService = affiliationService;
        this.configService = configService;
        this.storage = storage;
        this.siteId = 'dcl';
        this.url = '/resource-bundle${watcherSuffix}/${brand}/${locale}/homepage/';
        this.defaultAffiliation = 'standard';
        this.defaultProfile = 'looker';
        this.useWatcher = false;
        this.sessionTTL = 60000 * 4; // 4 minutes
        var toggles = this.configService.getValue('toggles');
        this.useWatcher = toggles.useWatcherForHomepageContent;
        if (toggles.resourceBundleStorageTTL) {
            this.sessionTTL = toggles.resourceBundleStorageTTL;
        }
    }
    ResourceBundleService.prototype.get = function (type) {
        var _this = this;
        return this.getCachedContent().then(function (content) {
            var _a;
            var storyOrderingPreset = content.storyOrderingPresets.presets.A;
            content = _this.extractRelevantStoriesData(content, type);
            content = content.sort(function (a, b) {
                var val = parseInt(a.generalPurposeStrings.order, 10) - parseInt(b.generalPurposeStrings.order, 10);
                return val;
            });
            return _a = {}, _a[type] = content, _a.storyOrderingPreset = storyOrderingPreset, _a;
        });
    };
    ResourceBundleService.prototype.getCachedContent = function () {
        var _this = this;
        var url = this.getURL();
        var cache = this.storage.getItem(url);
        return this.affiliationService.getAffiliations('dcl').then(function (affiliations) {
            _this.extractUserInfo(affiliations);
            if (cache) {
                return Promise.resolve(JSON.parse(cache));
            }
            else {
                return _this.httpClient.get(url).toPromise().then(function (content) {
                    // old homepage didn't have an expire for non-watcher service, but we'll do
                    // it for both here since all brands will eventually move to watcher anyway
                    var expireTime = new Date().getTime() + _this.sessionTTL; // 4 mins in the future
                    var expireIsoDate = new Date(expireTime).toISOString();
                    _this.storage.setItem(url, JSON.stringify(content), expireIsoDate);
                    return content;
                });
            }
        });
    };
    ResourceBundleService.prototype.getURL = function () {
        var locale = this.localeService.getLocale() || 'en';
        var brand = 'dcl';
        var watcherSuffix = this.useWatcher ? '-watcher' : '';
        return interpolate(this.url, { brand: brand, locale: locale, watcherSuffix: watcherSuffix });
    };
    /*
     * Filter content based on the current user's affiliation(s)/profile(s)
     * @param {Object} resource bundle content
     * @param {String} content type to return (heroes|stories)
     * @returns {Array} filtered stories content
     */
    ResourceBundleService.prototype.extractRelevantStoriesData = function (dataBundle, dataSet) {
        var currentUserAffiliations = this.currentUserInfo.affiliations;
        var chosenAffiliation;
        /* If there are more than 1 affiliations for the current user choose higher priority affiliation
          * higher index means higher priority
          */
        if (dataBundle.affiliationPriority &&
            dataBundle.affiliationPriority.length > 1 &&
            currentUserAffiliations.length > 1) {
            var currentPriority = -99;
            for (var j = 0; j < currentUserAffiliations.length; j++) {
                var checkAffil = currentUserAffiliations[j].toLowerCase(), checkIndex = dataBundle.affiliationPriority.indexOf(checkAffil);
                if (checkIndex > currentPriority) {
                    currentPriority = checkIndex;
                    var testAffiliation = dataBundle.affiliationPriority[checkIndex];
                    if (dataBundle[dataSet][testAffiliation] &&
                        dataBundle[dataSet][testAffiliation].length > 0) {
                        chosenAffiliation = dataBundle.affiliationPriority[checkIndex];
                    }
                }
            }
        }
        else if (dataBundle.affiliationPriority &&
            dataBundle.affiliationPriority.length === 1) {
            chosenAffiliation = dataBundle.affiliationPriority[0];
        }
        else {
            chosenAffiliation = this.defaultAffiliation;
        }
        return dataBundle[dataSet][chosenAffiliation];
    };
    ResourceBundleService.prototype.extractUserInfo = function (affiliation) {
        // Set default affiliation as fallback
        var affiliationList = [this.defaultAffiliation];
        // Create affiliation array and standardize default affiliation
        if (affiliation !== undefined &&
            affiliation[this.siteId] !== undefined &&
            affiliation[this.siteId].storedAffiliations !== undefined &&
            affiliation[this.siteId].storedAffiliations.length !== 0) {
            for (var key in affiliation[this.siteId].storedAffiliations) {
                if (affiliation[this.siteId].storedAffiliations[key] !== 'STD_GST') {
                    affiliationList.push(affiliation[this.siteId].storedAffiliations[key]);
                }
            }
        }
        // TODO: add in dynamic profile function instead of static text
        this.currentUserInfo = {
            affiliations: affiliationList,
            profile: this.defaultProfile
        };
        return this.currentUserInfo;
    };
    ResourceBundleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResourceBundleService_Factory() { return new ResourceBundleService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject(i3.AffiliationsService), i0.ɵɵinject(i4.ConfigService), i0.ɵɵinject(i5.ExpirableSessionStorageService)); }, token: ResourceBundleService, providedIn: "root" });
    return ResourceBundleService;
}());
export { ResourceBundleService };
